import get from 'lodash/get';
import { useSelector } from 'react-redux';

import { type AppState } from 'src/onboarding/redux/reducers';

/**
 * @example
 * import { useFeature } from 'common/hooks/useFeature';
 *
 * const MyComponent = () => {
 *   const hasSomeFeature = useFeature(FEATURES.SOME);
 *   return hasSomeFeature ? 'YES' : 'NO';
 * };
 */
export const useFeature = (feature: string): boolean => {
  return useSelector((state: AppState) => {
    const config = state?.global?.config;
    const features: Record<string, boolean> = get(config, 'features', {});

    return (
      Object.prototype.hasOwnProperty.call(features, feature) &&
      Boolean(features[feature])
    );
  });
};
